module.exports = __webpack_public_path__ + "img/p112.1c115558.jpg";